import Iconify from '@/components/Iconify';
import { Alert, AlertTitle, Box, Link } from '@mui/material';

export default function EventAlert({ title, message, hasLink }) {
  return (
    <Box sx={{ mt: '24px' }}>
      <Alert
        sx={{
          'background': '#FFF',
          'border': (theme) => `1px solid ${theme.palette.grey[300]}`,
          'color': (theme) => theme.palette.grey[600],
          '& .MuiAlert-icon': {
            fontSize: 40,
            color: '#1B8FFF',
          },
        }}
        icon={
          <Iconify
            icon="ph:info-fill"
            fontSize={24}
            sx={{ color: (theme) => theme.palette.primary.light }}
          />
        }
      >
        <AlertTitle sx={{ color: (theme) => theme.palette.grey[700] }}>
          {title}
        </AlertTitle>
        {message}{' '}
        {hasLink && (
          <Link
            variant="caption"
            underline="always"
            href="https://www.boletia.com"
          >
            boletia.com
          </Link>
        )}
      </Alert>
    </Box>
  );
}
